export default __webpack_public_path__ + "maps-examples-custom-callout-thumbnail-480-a226dd71455b6ba63452c9f3911b7dbc.png";